import React, { FC, useMemo } from 'react';

import { OptionType } from '@evinced-private/ui-common';

import { PLATFORM_APP_ID } from 'src/common/consts/dom-consts';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import {
	buildPanelInitialValues,
	mapToPanelDefinitions
} from 'src/common/helpers/FiltersPanelHelper';

import { useWebSdkTestsFilters } from '../../hooks/useWebSdkTestsFilters';

import { FilterSectionCommon } from './shared/FilterSectionCommon';
import { useFilterApplyHandler } from './shared/useFilterApplyHandler';
import { WebSdkTestsFilterSectionTitleRow } from './shared/WebSdkTestsFilterSectionTitleRow';

interface FilterSectionProps {
	isFilterOptionsLoading: boolean;
	filterOptions: {
		labels: OptionType[];
		properties: OptionType[];
		testPeriod: OptionType[];
	};
	filters?: IFilterOptions;
	showTestPath: boolean;
	showRecentTest: boolean;
	onShowRecentTestToggle: () => void;
}

export const FilterSection: FC<FilterSectionProps> = ({
	isFilterOptionsLoading,
	filterOptions,
	filters,
	showTestPath,
	showRecentTest,
	onShowRecentTestToggle
}) => {
	const { handleApply } = useFilterApplyHandler({ filterOptionsType: 'v1' });

	const { filterDefinitions, mergedFilterOptions } = useWebSdkTestsFilters({
		allLabels: filterOptions.labels,
		selectedLabels: filters?.labels ?? [],
		filterOptions,
		isV2: false
	});

	const panelDefinitions = useMemo(
		() => mapToPanelDefinitions(filterDefinitions),
		[filterDefinitions]
	);

	const initialValues = useMemo(
		() => buildPanelInitialValues(panelDefinitions, filters),
		[panelDefinitions, filters]
	);

	return (
		<FilterSectionCommon
			isFilterOptionsLoading={isFilterOptionsLoading}
			showTestPath={showTestPath}
			titleRow={
				<WebSdkTestsFilterSectionTitleRow
					showRecentTest={showRecentTest}
					onShowRecentTestToggle={onShowRecentTestToggle}
				/>
			}
			layoutClassName="product-filters-panel-layout"
			providerProps={{
				appElement: PLATFORM_APP_ID,
				onApply: handleApply,
				onReset: handleApply,
				initialValues,
				filterOptions: mergedFilterOptions,
				filterDefinitions: panelDefinitions
			}}
		/>
	);
};
